import { t } from 'i18n';
import { Modal, ModalBody, ModalHeader } from '@teko/ds-desktop';
import { BottomSheet } from '@teko/ds-mobile';
import React from 'react';
import {
  BottomSheetContent,
  Center,
  ResendOtpBtn,
  StyledNoti,
  StyledOTPInput,
} from './styles';
import { useUploadProfile } from '../hooks/useUploadProfile';
import { ProfileUpdate } from '@teko/user';

export const OtpConfirmationPopup = ({
  isMobile,
  waitingVerifyOTP,
  values,
  otpData,
  countdown,
  otpError,
  resendOTP,
  resetStates,
  verifyOtp,
}: Pick<
  ReturnType<typeof useUploadProfile>,
  | 'waitingVerifyOTP'
  | 'otpData'
  | 'resetStates'
  | 'countdown'
  | 'otpError'
  | 'resendOTP'
  | 'verifyOtp'
> & {
  isMobile?: boolean;
  values: Partial<ProfileUpdate>;
}) => {
  const bottomSheetType = otpData
    ? otpData?.email
      ? 'email'
      : 'telephone'
    : '';

  const handleHideOTPModal = () => resetStates();
  const handleOtpChange = async (otp: string, formValues: ProfileUpdate) => {
    if (otp.length === 6) {
      await verifyOtp(otp, formValues);
    }
  };
  return (
    <>
      {!isMobile ? (
        <Modal
          width="31rem"
          visible={waitingVerifyOTP}
          onClose={handleHideOTPModal}
          footer={false}
        >
          <ModalHeader>
            {t('Xác nhận')} {otpData?.telephone ? t('số điện thoại') : 'email'}
          </ModalHeader>
          <ModalBody>
            <Center>
              <span>
                {t('Vui lòng nhập mã OTP đã được gửi đến')}{' '}
                <strong>
                  {values[otpData?.telephone ? 'telephone' : 'email']}
                </strong>
              </span>
            </Center>
            <StyledOTPInput
              onChange={(otp: string) => handleOtpChange(otp, values)}
            />
            {otpError && <StyledNoti>{otpError}</StyledNoti>}
            <Center>
              <ResendOtpBtn
                disabled={countdown > 0}
                variant="link"
                onClick={resendOTP}
              >
                {countdown === 0
                  ? t('Gửi lại mã')
                  : t('Gửi lại mã sau {{countdown}}s', {
                      countdown: countdown,
                    })}
              </ResendOtpBtn>
            </Center>
          </ModalBody>
        </Modal>
      ) : (
        <BottomSheet
          zIndex={100}
          show={waitingVerifyOTP}
          title={
            bottomSheetType == 'email'
              ? t('Cập nhật email')
              : t('Cập nhật số điện thoại')
          }
          closeBottomSheet={handleHideOTPModal}
        >
          <BottomSheetContent>
            <>
              <div>
                {t('Vui lòng nhập mã OTP đã được gửi đến ')}
                <strong>{bottomSheetType && otpData?.[bottomSheetType]}</strong>
              </div>
              <StyledOTPInput
                onChange={(otp: string) => handleOtpChange(otp, values)}
              />
              {otpError && <StyledNoti>{otpError}</StyledNoti>}
              <Center>
                <ResendOtpBtn
                  disabled={countdown > 0}
                  onClick={() => resendOTP()}
                >
                  {countdown === 0
                    ? t('Gửi lại mã')
                    : t('Gửi lại mã sau {{countdown}}s', {
                        countdown: countdown,
                      })}
                </ResendOtpBtn>
              </Center>
            </>
          </BottomSheetContent>
        </BottomSheet>
      )}
    </>
  );
};
